import { render, staticRenderFns } from "./SectionDetails.vue?vue&type=template&id=05e422ba&scoped=true"
import script from "./SectionDetails.vue?vue&type=script&lang=js"
export * from "./SectionDetails.vue?vue&type=script&lang=js"
import style0 from "./SectionDetails.vue?vue&type=style&index=0&id=05e422ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e422ba",
  null
  
)

export default component.exports